import { useCallback } from "react";
import { QuizApi } from "@jti/rest-api";
export const useQuizApi = (quizData, uuid, userEmail) => {
    const quizApi = QuizApi.init();
    const checkQuizState = useCallback(async () => {
        if (!uuid || !quizData.uuid) {
            return null;
        }
        try {
            const { data = [] } = await quizApi.getUserSubmissions(uuid);
            const matchingSubmissions = data.filter((submission) => {
                return submission.quiz_payload.results.some((result) => {
                    return result.quiz_uuid === quizData.uuid;
                });
            });
            if (!matchingSubmissions.length) {
                return null;
            }
            const latestSubmission = matchingSubmissions.reduce((latest, current) => {
                const currentTimestamp = current.quiz_payload.results[0].created_at || 0;
                const latestTimestamp = latest.quiz_payload.results[0].created_at || 0;
                return currentTimestamp > latestTimestamp ? current : latest;
            }, matchingSubmissions[0]);
            return latestSubmission;
        }
        catch (error) {
            console.error("Error checking quiz state:", error);
            return null;
        }
    }, [uuid, quizData.uuid, quizApi]);
    const submitQuizAnswer = useCallback(async (answers) => {
        if (!uuid)
            return;
        try {
            const submission = {
                answers: quizData.answerDimensions.payload,
                questions: quizData.questionDimensions.payload,
                results: [
                    {
                        type: "SOURCE_OF_BUSINESS",
                        email: userEmail,
                        quiz_uuid: quizData.uuid,
                        answers: [...answers],
                        created_at: Date.now(),
                    },
                ],
            };
            await quizApi.createSubmission(uuid, submission);
            return true;
        }
        catch (error) {
            console.error("Failed to submit answer:", error);
            return false;
        }
    }, [uuid, quizData, userEmail, quizApi]);
    return {
        checkQuizState,
        submitQuizAnswer,
    };
};
//# sourceMappingURL=useQuizApi.js.map